import Api from 'src/api/Base'

class GetChangeControlReasons extends Api {
  requestUrl = '/api/ChangeControl/GetReasons'
}

export default GetChangeControlReasons
